import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from 'src/app/_service/api-service.service';
declare var $: any;

@Component({
  selector: 'app-student-enroll',
  templateUrl: './student-enroll.component.html',
  styleUrls: ['./student-enroll.component.scss']
})
export class StudentEnrollComponent implements OnInit {
  mentor: any = JSON.parse(localStorage.getItem('login_user_details'));
  courses: any[] = [];
  tableshow: boolean = false;
  spinner: boolean = true;
  selectedStudent: any = null; // Variable to store the selected student's details
  modalTitle: string = '';



  constructor(private fb: FormBuilder, private ApiService: ApiServiceService, private router: Router,
    private spinnerService: NgxSpinnerService) {
  
  }

  ngOnInit(): void {
    this.studentsEnrollCourse();
    this.handleBackButtonForModal();


  }
  handleBackButtonForModal() {
    // Push initial state to history
    history.pushState(null, '', window.location.href);
  
    window.onpopstate = () => {
      const modal = document.querySelector('.modal.show') as HTMLElement;
      if (modal) {
        // Find the close button inside the modal and trigger a click event on it
        const closeButton = modal.querySelector('.close') as HTMLElement;
        if (closeButton) {
          closeButton.click();
        }
  
        // Prevent default back navigation
        history.pushState(null, '', window.location.href);
      } else {
        // Allow back navigation as usual if modal is not open
        this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
      }
    };
  }
  ngOnDestroy(): void {
    // Cleanup event listener to avoid memory leaks
    window.onpopstate = null;
  }
  
  studentsEnrollCourse(): void {
    const mentor_id=this.mentor.id;
    console.log(this.mentor);
    this.ApiService.getCoursesAndStudentsByMentor(mentor_id).subscribe(
      (response:any) => {
        if (response.status === 'success') {

          this.courses = response.courses;
          this.tableshow = true;
          this.spinner = false;
            // Assuming the backend returns an array of students
        } else {
          console.error(response.message);
        }
      },
      error => {
        console.error('Error fetching courses and students', error);
      }
    );
  }
  show(course: any, action: string) {
    console.log(course);
    if (course) {
      // Assuming you want to show details of the first student in the course
      this.selectedStudent = {
        course_name: course.course_name,
        course_date: course.course_date,
        course_time: course.course_time,
        student_name: course.student_name,
        student_email: course.student_email,
        student_number: course.student_number,
        student_p_n: course.student_p_n
      };
  
      // Set modal title
      this.modalTitle = action === 'edit' ? 'Edit Student’s Detail' : 'Student’s Detail';
  
      // Use jQuery to show the modal
      $('#myModal').modal('show');
    }
  }
  
}